// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"174":"3d27cb59","316":"9e3cbb79","345":"423d9bdb","417":"34d4b7c1","473":"2cd1fcdd","694":"94b74d69","698":"cfdd207a","839":"85cfd875"}[chunkId] + ".js";
};